export default __webpack_public_path__ + "static/trackingImg-4e8f4021351da2a164e86ad70d0aa34e.svg";